import PlacementController from "../../../output/assets/objects/placement-controller.js";

class ThreePlacementController extends PlacementController {
    constructor() {
        super();
    }

    setPosition(object, x, y, z) {
        object.position.set(x, y, z);
    }

    setEulerRotation(object, x, y, z, order) {
        object.rotation.set(x, y, z, order);
    }

    setQuaternionRotation(object, x, y, z, w) {
        object.quaternion.set(x, y, z, w);
    }

    setScale(object, x, y, z) {
        object.scale.set(x, y, z);
    }
}

export default ThreePlacementController;
